import React from 'react';

/* Compteurs de fin d'import : importées, mises à jour, supprimées, déjà existantes, non matchées. */
export default function YearImportStats({ ym }) {
  const nbUnmatched = (ym.unmatched || []).length;
  const cartes = [
    { label: 'Importées', value: ym.inserted, className: 'text-[18px] font-bold text-success' },
    {
      label: 'Mises à jour',
      value: ym.updated || 0,
      color: (ym.updated || 0) > 0 ? '#1D9E75' : 'inherit',
    },
    {
      label: 'Supprimées',
      value: ym.deleted || 0,
      color: (ym.deleted || 0) > 0 ? '#C0481B' : 'inherit',
    },
    { label: 'Déjà existantes', value: ym.skipped },
    { label: 'Non matchées', value: nbUnmatched, color: nbUnmatched > 0 ? '#E8A838' : 'inherit' },
  ];
  return (
    <div className="flex gap-[10px] mb-[12px]">
      {cartes.map((c) => (
        <div key={c.label} className="stat-card [flex:1]">
          <div className="text-[11px] text-grey mb-[2px]">{c.label}</div>
          <div
            className={c.className || 'text-[18px] font-bold'}
            style={c.color ? { color: c.color } : undefined}
          >
            {c.value}
          </div>
        </div>
      ))}
    </div>
  );
}
